import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Row, Col, Card, Typography, Form, Select,
  Input, Checkbox, Button, message
} from 'antd';
import {
  UserOutlined, LockOutlined,
  EyeTwoTone, EyeInvisibleOutlined
} from '@ant-design/icons';
import colleges from '../bd.json';

const { Title, Text, Link } = Typography;
const { Option } = Select;

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const collegeOpts = useMemo(
    () => colleges.map(c => ({ id: c.id, name: c.college_name.trim() })),
    []
  );

  const handleCollegeChange = (id) => {
    const found = colleges.find(c => c.id === id);
    if (found) {
      form.setFieldsValue({
        login: (found.username || found.college_email || '').trim(),
      });
    }
  };

  const onFinish = (vals) => {
    setLoading(true);
    const found = colleges.find(c =>
      c.id === vals.collegeId &&
      (c.username || c.college_email)?.trim().toLowerCase() === vals.login.trim().toLowerCase() &&
      c.password === vals.password
    );

    if (found) {
      localStorage.setItem('auth', JSON.stringify({
        ...found,
        currentLogin: vals.login.trim(),
        remember: vals.remember,
      }));
      message.success(`Добро пожаловать, ${found.college_name.trim()}`);
      navigate('/dashboard', { replace: true });
    } else {
      message.error('Неверный логин или пароль');
    }
    setLoading(false);
  };

  return (
    <Row
      justify="center"
      align="middle"
      style={{ minHeight: '100vh', background: '#f0f2f5' }}
    >
      <Col xs={22} sm={16} md={12} lg={8}>
        <Card
          bordered={false}
          style={{ borderRadius: 12, boxShadow: '0 4px 18px rgba(0,0,0,.05)' }}
          bodyStyle={{ padding: 40 }}
        >
          <Title level={3} style={{ textAlign: 'center', marginBottom: 8 }}>
            Вход в систему
          </Title>
          <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 32 }}>
            Выберите колледж и введите учётные данные
          </Text>

          <Form
            form={form}
            layout="vertical"
            size="large"
            onFinish={onFinish}
            initialValues={{ remember: true }}
          >
            <Form.Item
              label="Колледж"
              name="collegeId"
              rules={[{ required: true, message: 'Укажите колледж' }]}
            >
              <Select
                placeholder="Выберите колледж"
                onChange={handleCollegeChange}
                showSearch
                optionFilterProp="children"
                filterOption={(i, o) => o.children.toLowerCase().includes(i.toLowerCase())}
              >
                {collegeOpts.map(o => (
                  <Option key={o.id} value={o.id}>{o.name}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="E-mail / логин"
              name="login"
              rules={[{ required: true, message: 'Введите логин или e-mail' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Логин или e-mail"
              />
            </Form.Item>

            <Form.Item
              label="Пароль"
              name="password"
              rules={[{ required: true, message: 'Введите пароль' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Пароль"
                iconRender={vis => vis ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
              />
            </Form.Item>

            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox style={{ marginBottom: 16 }}>Запомнить меня</Checkbox>
            </Form.Item>

            <div style={{ textAlign: 'right', marginBottom: 32 }}>
              <Link href="#">Забыли пароль?</Link>
            </div>

            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
            >
              Войти
            </Button>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}
